import { Component, OnInit, ViewChild } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { filter, first, map } from 'rxjs/operators';
import { stringToJson, replaceBetween } from '../helpers/functions';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaildDialogComponent } from '../faild-dialog/faild-dialog.component'
import { Platform } from '@angular/cdk/platform';
import { createViewChild } from '@angular/compiler/src/core';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-payment-multi',
  templateUrl: './payment-multi.component.html',
  styleUrls: ['./payment-multi.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class PaymentMultiComponent implements OnInit {
  @ViewChild('stepper',{static:false}) stepper: MatStepper;
  title = 'sadan-web-payment';
  currentLanguage: string = 'ar';
  href = new URL(window.location.href);
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  paymentMethods = [];
  cartData = [];
  deviceId;
  userId;
  token;
  transactionId;
  paymentId;
  locale = "ar";
  platform = "m";
  cartTotal: any = 0;
  cartCurrent:any = 0;
  paymentComplete: boolean = false
  placeDetails = {
    name_ar:"",
    name_en:"",
  };
  fees:number = 0;
  selectedStep = 0;
  trackId = 0;
  loading = true;
  paymentSuccess = true;
  deliveryTime;
  orders:any = {
    donateDetails:[],
  };

  constructor(
    private _formBuilder: FormBuilder,
    private route:ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private translate: TranslateService,
    public dialog: MatDialog,
    private platformData: Platform,
    private helper: HelperService,
) 
{ 
    this.translate.onLangChange.subscribe(data => {
      if (data.lang == 'ar') {
        this.currentLanguage = 'ar';
      } else {
        this.currentLanguage = 'en';
      }
    })
}

  async ngOnInit() {
    /*if(this.platformData.ANDROID || this.platformData.IOS || this.platformData.WEBKIT) {
      this.platform = "m";
    }else{
      this.platform = "p";
    }*/
    this.deviceId = this.route.snapshot.paramMap.get('deviceId');
    this.userId = this.route.snapshot.paramMap.get('userId');
    this.transactionId = this.route.snapshot.paramMap.get('transactionId');
    this.token = this.route.snapshot.paramMap.get('token');
    this.locale = this.route.snapshot.paramMap.get('locale');
    this.platform = this.route.snapshot.paramMap.get('platform') == "p" ? "p" : "m";
    this.paymentId = this.route.snapshot.queryParamMap.get("paymentId");
    if(this.locale) this.useLanguage(this.locale);
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: [null, [Validators.required]],
      userPhone: [null,[Validators.required, Validators.pattern(/^[9654]\d{7}$/)]],
      reciverPhone: ["",],
      notes: ["",],
    });
    try{
      if(!this.paymentId){
        await this.getTotalInvoice();
        await this.getPaymentMethods(this.cartTotal);
        this.loading = false;
      }else{
        //now select last step and check payment status
        this.paymentComplete = true;
        setTimeout(() => {
          this.stepper.selectedIndex = 2;
        });
        //lets send paymentId to backend
        await this.http.get(environment.configs.crosApi+environment.configs.sadanApi+`payment/success?paymentId=${this.paymentId}`).pipe(first()).toPromise();
        //now lets check payment data
        const data = {
          "Key": this.paymentId,
          "KeyType": "PaymentId"
        }
        //lets check if payment is success
        const checkPaymentSuccess = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "GetPaymentStatus",data,this.Headers()).pipe(first()).toPromise();
        //console.log(JSON.parse(`${checkPaymentSuccess["IsSuccess"]}`),checkPaymentSuccess);
        if(checkPaymentSuccess["IsSuccess"]){
          if (checkPaymentSuccess['Data']['InvoiceStatus'] != 'Paid') {
            // un pack products with offers 
            await this.http.get(environment.configs.crosApi+environment.configs.sadanApi +  `unpack-products/${this.transactionId}`).pipe(first()).toPromise();
            this.paymentSuccess = false;
            this.loading = false;
            return this.messageDialog('Please pay this invoice');
          }
          //console.log(checkPaymentSuccess["Data"]["UserDefinedField"]);
          //console.log("success")
          this.paymentComplete = true;
          const prepareUser = checkPaymentSuccess["Data"]["UserDefinedField"].replace(new RegExp('\r?\n','g'), '<br/>');
          //console.log(prepareUser)
          //now lets send donate to our db
          const donateData = {
            deviceId:this.deviceId,
            userId:this.userId == Number((JSON.parse(prepareUser)["userId"])) ? Number((JSON.parse(prepareUser)["userId"])):0,
            paymentId:this.paymentId,
            transactionId: this.transactionId,
          }
          const sendDonate:any = await this.http.post(environment.configs.crosApi+environment.configs.sadanApi +  "multi-donates",donateData).pipe(first()).toPromise();
          if(sendDonate){
            this.trackId = sendDonate.join(",");
            this.paymentSuccess = true;
            const time:any = await this.http.get(environment.configs.crosApi+environment.configs.sadanApi +  "delivery-time").pipe(first()).toPromise();
            this.deliveryTime = time["multiDonationDeliveryTime_" + this.translate.currentLang];
          }
          this.loading = false;
        }else{
          // Unpack products if they sold in an offer
          await this.http.get(environment.configs.crosApi+environment.configs.sadanApi +  `unpack-products/${this.transactionId}`).pipe(first()).toPromise();
          this.paymentSuccess = false;
          this.loading = false;
          this.messageDialog("Please pay this invoice");
        }
      }
    }catch(error){
      this.paymentSuccess = false;
      this.loading = false;
      console.log(error)
      this.messageDialog(error.error.error.message);
      //this.errorDialog();
    }
  }

  ngAfterContentChecked() {
    if(this.paymentId && this.paymentComplete){
      this.selectedStep = 2;
    }
  }
  
  async getTotalInvoice(){
    const headers = {
      headers:{
        'Content-Type': 'application/json',
      }
    }
    const body = {
      userId: parseInt(this.userId),
      deviceId: this.deviceId,
      transactionId: this.transactionId,
    }
    try{
      let placeData:any = await this.http.post(environment.configs.crosApi+environment.configs.sadanApi +  `get-transaction`,body,headers).pipe(first()).toPromise();
      this.orders = placeData;
      //now we have fees lets calculate new total
      this.cartTotal = placeData.total;
      this.cartCurrent = placeData.totalWithoutFees;
      this.fees = placeData.totalFees;
      placeData.donateDetails.forEach(element => {
        element.order.forEach(each => {
          this.cartData.push({
            itemName: each.itemName_ar,
            itemPrice: each.itemPrice,
            quantity: each.quantity,
          });
        })
      });
      console.log(this.cartData)
    }catch(error){
      this.messageDialog("Cannot get transaction");
    }
  }

  async ValidateTempOredrs(stepper: MatStepper) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      await this.http
        .get(
          environment.configs.crosApi+environment.configs.sadanApi + 
            `temp-oredr/validate/${this.transactionId}`, headers
        )
        .pipe(first())
        .toPromise();
      await this.checkPayment(stepper);
    } catch (error) {
      return this.messageDialog("Temp Order has expired");
    }
  }
  async getPaymentMethods(totalPayment){
    const data = {
      "InvoiceAmount": totalPayment,
      "CurrencyIso": "KWD"
    }
    const methodsData = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "InitiatePayment",data,this.Headers()).pipe(first()).toPromise();
    if(methodsData.hasOwnProperty("Data")){
      if(methodsData["Data"].hasOwnProperty("PaymentMethods")){
        this.paymentMethods = methodsData["Data"]["PaymentMethods"].filter(data => data.PaymentMethodId == 1 || data.PaymentMethodId == 2);
      }
    }
  }

  Headers(){
    return  {
      headers:{
        'Authorization': 'Bearer ' + environment.configs.myFatoorahToken,
        'Content-Type': 'application/json',
      },
    }
  }

  goToApp(){
    if(this.platform == "m"){
      window.open("sadanappkwt://sadankwt.com/");
    }else{
      const url = environment.configs.appHost;//this.href.protocol + "//" + this.href.host + '/home/';
      window.location.href = url;
    }
    //window.location.href = 'sadanappkwt://sadankwt.com/';
  }

  // if user completed payment method skip step 2 and go to step 3 (completed)
  async checkPayment(stepper: MatStepper) {
    if(this.firstFormGroup.invalid || this.cartTotal <= 0) return this.errorDialog();
    //console.log(this.firstFormGroup.value)
    try{
      let userName = "فاعل خير";
      let userPhone = null;
      let userEmail = null;
      let userInfo;
      if(this.userId != 0){
        userInfo = await this.http.get(environment.configs.crosApi+environment.configs.sadanApi +  "users/me",{
          headers:{
            'Authorization': 'Bearer ' + this.token,
            'Content-Type': 'application/json',
          }
        })
        .pipe(first())
        .toPromise();
        userName = userInfo.username;
        //userPhone = userInfo.phone.replaceAt("+965", "");
        if(userInfo.phone.substr(0, 4) == "+965"){
          userPhone = replaceBetween(userInfo.phone,0, 4,"");
        }else if(userInfo.phone.substr(0, 5) == "00965"){
          userPhone = replaceBetween(userInfo.phone,0, 5,"");
        }else{
          userPhone = userInfo.phone;
        }
        userEmail = userInfo.email;
      }
      const formData = this.firstFormGroup.value;
      const mathodId = formData.firstCtrl;
      let callBackUrl = `${environment.configs.paymentCallBack}${this.deviceId}/${this.userId}/0/${this.transactionId}/${this.locale}/`;
      if(this.platform) callBackUrl += this.platform + "/";
      const cartData = {
        "PaymentMethodId": mathodId,
        "CustomerName": userName,
        "DisplayCurrencyIso": "KWD",
        "MobileCountryCode": "+965",
        "CustomerMobile": userPhone,
        "CustomerEmail": userEmail,
        "InvoiceValue": this.cartTotal.toFixed(2),
        "CallBackUrl": callBackUrl,
        "ErrorUrl": `${environment.configs.paymentCallBack}${this.deviceId}/${this.userId}/0/${this.transactionId}/${this.locale}/`,
        "Language": "AR",
        "UserDefinedField": `{"userId":"${this.userId != 0 ? this.userId:this.deviceId}","reciverPhone":"${formData.reciverPhone}","notes":"${formData.notes}","userPhone":"${formData.userPhone}"}`,
        "InvoiceItems": []
      }
      this.cartData.forEach(data => {
        cartData["InvoiceItems"].push({
          ItemName: data["itemName"],
          Quantity: data["quantity"],
          UnitPrice: data["itemPrice"]
        })
      });
      if (this.fees != 0) {
        cartData["InvoiceItems"].push({
          ItemName: "delivery_fees",
          UnitPrice: this.fees,
          Quantity: 1
        });
      }
      //console.log(cartData)
      const methodsData = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "executePayment",cartData,this.Headers()).pipe(first()).toPromise();
      if(methodsData){
        if(methodsData.hasOwnProperty("Data")){
          if(methodsData["Data"].hasOwnProperty("PaymentURL")){
            //console.log((stringToJson(methodsData["Data"]["UserDefinedField"])["userId"]).toString())
            this.paymentComplete = true;
            setTimeout(() => {
              this.stepper.selectedIndex = 1;
            });
            const payUrl = methodsData["Data"]["PaymentURL"];
            window.location.href = payUrl;
          }
        }
      }
      //stepper.selectedIndex = 2//index - 1;
      //stepper.steps.last.select()
      //console.log()
    }catch(error){
      this.loading = false;
    /* alert("هناك خطأ") */
      const dialogRef = this.dialog.open(FaildDialogComponent, {
        width: '530px',
        data: { errorType: 'connection',platform:this.platform, }, //error type may ba payment or connection
        disableClose:true,
        /* data: { errorType: 'connection' } */
      });
    }
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  errorDialog(){
    const dialogRef = this.dialog.open(FaildDialogComponent, {
      width: '530px',
      data: { errorType: 'connection',platform:this.platform, },
      disableClose:true,
    });
  }

  messageDialog(message){
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '530px',
      data: { message },
      disableClose:true,
    });
  }

  errorPaymentDialog(){
    const dialogRef = this.dialog.open(FaildDialogComponent, {
      width: '530px',
      data: { errorType: 'payment',platform:this.platform, },
    });
  }
}
